// extracted by css-extract-rspack-plugin
export default {"info":"_98212af7","small":"_c470b286","associations":"_9c9f533","compact":"_48483b7e","associationsList":"_eb2c2e31"};